export const parseLocalDate = (dateString) => {
  if (!dateString) return null;

  const [year, month, day] = dateString.split('-').map(Number);
  if ([year, month, day].some((value) => Number.isNaN(value))) {
    return null;
  }

  return new Date(year, month - 1, day);
};

export const countWeekdays = (startDate, endDate) => {
  if (!startDate || !endDate) return 0;

  const start = parseLocalDate(startDate);
  const end = parseLocalDate(endDate);

  if (!start || !end || Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return 0;
  }

  const firstDate = start <= end ? start : end;
  const lastDate = start <= end ? end : start;

  let total = 0;
  const current = new Date(firstDate);

  while (current <= lastDate) {
    const dayOfWeek = current.getDay();

    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      total += 1;
    }

    current.setDate(current.getDate() + 1);
  }

  return total;
};
